import httpApiApplication from '../../../../http/httpApiApplication';
import { type OperationReportRequest } from '../models/types';

export const baseUrl = '/reportvector';

export const saveReportOperation = (
  request: OperationReportRequest
): Promise<{ reportVectorId: string }> => {
  return httpApiApplication.post(baseUrl, request);
};

export const deleteReportOperation = (
  request: OperationReportRequest
): Promise<{ taxVectorId: string }> => {
  return httpApiApplication.delete(
    `${baseUrl}/report/${request.reportId}/operation/${request.operationId}`
  );
};
